import { render, staticRenderFns } from "./CertifiedSection.vue?vue&type=template&id=3e81ea1e&scoped=true"
import script from "./CertifiedSection.vue?vue&type=script&lang=js"
export * from "./CertifiedSection.vue?vue&type=script&lang=js"
import style0 from "./CertifiedSection.vue?vue&type=style&index=0&id=3e81ea1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e81ea1e",
  null
  
)

export default component.exports